import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=6fd10165&scoped=true&"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js&"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFormItem.vue?vue&type=style&index=0&id=6fd10165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd10165",
  null
  
)

export default component.exports